var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg09C(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.6 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.53,26.17c6.21.74,10.57,2.46,10.57,4.48,0,2.68-7.75,4.85-17.3,4.85S.5,33.33.5,30.65c0-2,4.35-3.74,10.56-4.48"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.66,
    cy: 11.34,
    r: 3.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.5,11.34c0,4.31-2.83,8.44-5,11.74-2.78,4.3-5.1,7.3-5.87,8.58-.76-1.26-3.11-4.36-5.87-8.58-2.18-3.33-5-7.36-5-11.74a10.84,10.84,0,0,1,21.68,0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg09C);
export default __webpack_public_path__ + "static/media/09c.e5dcb1a93557fb09eafb5ae2eda2ef5a.svg";
export { ForwardRef as ReactComponent };